import { DocumentModel } from '../document/types';
import { AccountMoveModel } from '../accounting/types';
import { ContractStatus } from '../contract/types';

export const insuranceClaimFeatureKey = 'insuranceClaim';

/**
 * Claim status — the API serializes the InsuranceClaimStatus enum by NAME (JsonStringEnumConverter),
 * so statusId is the enum member name, not an int.
 */
export type InsuranceClaimStatus =
  | 'Open'
  | 'InProgress'
  | 'TransmittedToInsurer'
  | 'DossierOpenedAtInsurer'
  | 'Closed'
  | 'Rejected';

export type InsuranceClaimModel = {
  id: number;
  name: string;
  uniqueId: string;
  internalId: string;
  contractId: number;
  contractUniqueId: string;
  contractName: string;
  contractProductCategoryId: number;
  contactId: number;
  contactName: string;
  claimTypeId: number;
  claimTypeName: string;
  occurrenceDate?: Date;
  declarationDate?: Date;
  estimatedAmount?: number;
  description: string;
  salesPersonId?: number;
  salesPersonContactName?: string;
  claimStatus: InsuranceClaimStatus;
  claimStatusId: number;
  claimStatusLoc: string;
  claimStatusColor: string;
  insuranceClaimStatusHistories: InsuranceClaimStatusHistoryModel[];
  documents: DocumentModel[];
  /** Quittances de frais de sinistre + paiements liés. */
  clientAccountMoves?: AccountMoveModel[];
  /** Compagnie d'assurance du contrat porteur, pour le domaine des comptes des modales de quittance. */
  contractProductProductLineInsuranceCompanyContactId?: number;
  liabilityRate?: number;
  deductibleAmount?: number;
};

export type InsuranceClaimFormModel = {
  id: number;
  uniqueId: string;
  name: string;
  contractId: number;
  claimTypeId: number;
  occurrenceDate?: Date;
  declarationDate?: Date;
  estimatedAmount: number;
  description: string;
  salesPersonId?: number;
  contractProductCategoryId: number;
  liabilityRate?: number;
  deductibleAmount?: number;
};

export type InsuranceClaimRejectReasonModel = {
  insuranceClaimId: number;
  rejectReason: string;
};

export type InsuranceClaimStatusHistoryModel = {
  id: number;
  insuranceClaimId: number;
  fromStatus?: InsuranceClaimStatus;
  fromStatusLoc: string;
  toStatus: InsuranceClaimStatus;
  toStatusLoc: string;
  statusColor: string;
  changeDate: string;
  userId?: number;
  userContactName?: string;
};

export type InsuranceClaimStatusFlow = {
  label: string;
  status: InsuranceClaimStatus;
  statusId: number;
  statusColor: string;
};
